/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {REDESCLARAS, SECCIONES} from "../Constantes";
import logo from '../Recursos/logo_icono.svg'
import {useNavigate} from "react-router";
import {scrolearAComponente} from "../Utilidades/scrolearAComponente";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politicas from "./Dialogos/Dialogo_Politicas";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../App";
import {irUrl} from "../Utilidades/irUrl";

const Footer = () => {
    const navigate = useNavigate()
    const cData = useContext(contexApp)
    const {sCell, masSM, sTab} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politicas})
    const [configuraciones, setconfiguraciones] = useState({})


    const click = (id) => {
        switch (id) {
            case 'compra':
                abrir({texto: configuraciones.politica_envio})
                break
            case 'datos':
                abrir({texto: configuraciones.politica_protenccion})
                break
        }
    }
    const irRuta = (ruta) => {

        if (ruta === SECCIONES[0]) {
            navigate('/Home')
            setTimeout(() => {
                scrolearAComponente(SECCIONES[0])
            }, 500)

        } else {
            navigate(`/${ruta}`)
        }
    }


    useEffect(() => {

        if (cData.configuraciones && cData.configuraciones.length > 0) {
            setconfiguraciones(cData.configuraciones[0])
        }

    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#000', py: 8, overflow: 'hidden'}}

        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', pt: 2, pb: 0, px: sCell ? 4 : 6, color: '#fff'}}
            >

                <h1 style={{display: 'none'}}>Moda Colombiana</h1>
                <h2 style={{display: 'none'}}>Pantalones Mujer</h2>
                <h2 style={{display: 'none'}}>Accesorios Mujer</h2>

                <Grid container size={{xs: 12, sm: 4, md: 2.5}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <Typography sx={{fontSize: 24, fontWeight: 400, fontFamily: 'Dm Serif Display'}}>
                                LINKS RÁPIDOS
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={1}
                            >


                                {SECCIONES.map((it, index) => {
                                    return (
                                        <Grid
                                            onClick={() => irRuta(it)}
                                            container size={{xs: 12, sm: 12, md: 12}}>
                                            <Typography
                                                sx={{
                                                    transition: 'all .2s ease-in-out',
                                                    color: '#fff',
                                                    fontSize: 16,
                                                    fontWeight: 400,
                                                    cursor: 'pointer',
                                                    borderBottom: 1,
                                                    borderColor: '#ffffff00',
                                                    '&:hover': {
                                                        borderColor: '#fff',
                                                    }
                                                }}
                                            >
                                                {it.substring(0, 1) + it.substring(1, it.length).toLowerCase()}
                                            </Typography>
                                        </Grid>
                                    )
                                })}


                                <Grid
                                    onClick={() => navigate('/Todos')}
                                    container size={{xs: 12, sm: 12, md: 12}}>
                                    <Typography
                                        sx={{
                                            transition: 'all .2s ease-in-out',
                                            color: '#fff',
                                            fontSize: 16,
                                            fontWeight: 400,
                                            cursor: 'pointer',
                                            borderBottom: 1,
                                            borderColor: '#ffffff00',
                                            '&:hover': {
                                                borderColor: '#fff',
                                            }
                                        }}
                                    >
                                        Todos los productos
                                    </Typography>
                                </Grid>

                            </Grid>

                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 4, md: 3}} sx={{mt: sCell ? 3 : 0}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <Typography sx={{fontSize: 24, fontWeight: 400, fontFamily: 'Dm Serif Display'}}>
                                POLÍTICAS
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={1}
                            >


                                <Grid
                                    onClick={() => click('compra')}
                                    container size={{xs: 12, sm: 12, md: 12}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 400, cursor: 'pointer'}}>
                                        Políticas de Compra
                                    </Typography>
                                </Grid>

                                <Grid
                                    onClick={() => click('datos')}
                                    container size={{xs: 12, sm: 12, md: 12}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 400, cursor: 'pointer'}}>
                                        Políticas de Privacidad
                                    </Typography>
                                </Grid>

                            </Grid>

                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 4, md: 3}} sx={{mt: sCell ? 3 : 0}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <Typography sx={{fontSize: 24, fontWeight: 400, fontFamily: 'Dm Serif Display'}}>
                                NOSOTROS
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{mt: 1}}>
                            <Typography sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.4, textAlign: 'justify'}}>
                                En ÂMEVI la moda es esencia y autenticidad.
                                Prendas que te inspiran a vivir segura y con estilo.

                                Hecho en Colombia.

                            </Typography>
                        </Grid>
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                            <Typography sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.4}}>


                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                {REDESCLARAS.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 2, sm: 2, md: 2}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <img
                                                onClick={() => irUrl(it.url)}
                                                src={it.icono} width={32} height={'auto'} style={{cursor: 'pointer'}}/>
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 3.5}}
                      sx={{
                          mb: !masSM ? 4 : -26,
                          mt: !masSM ? 4 : -2,
                          justifyContent: !masSM ? 'center' : 'flex-start'
                      }}>
                    <img src={logo} width={sCell ? '50%' : sTab ? '20%' : '125%'} height={'auto'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 8}} justifyContent={'center'} sx={{mt: 2}}>
                    <Typography sx={{textAlign: 'center'}}>TODOS LOS DERECHOS RESERVADOS © AMEVI 2025 -
                        2026</Typography>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Footer